import { Link } from 'react-router';

interface NavItemProps {
    to: string;
    label: string;
    glyph: React.ReactNode;
    active: boolean;
    indented?: boolean;
    badge?: React.ReactNode;
}

/**
 * One sidebar row.
 *
 * The prototype draws these as <div data-nav="…">, which is neither a link nor focusable. They are
 * real links here so the sidebar can be navigated by keyboard and read by a screen reader, and the
 * active row carries aria-current rather than relying on its background tint.
 */
export default function NavItem({ to, label, glyph, active, indented = false, badge }: NavItemProps) {
    return (
        <Link
            to={to}
            aria-current={active ? 'page' : undefined}
            className={`flex items-center gap-[11px] rounded-[10px] ${
                indented ? 'ml-[18px] text-[13.5px] px-3 py-2' : 'text-sm px-3 py-2.5'
            } ${active ? 'bg-white/15 font-semibold text-white' : 'text-sidebar-ink hover:bg-white/10'}`}
        >
            <span aria-hidden="true">{glyph}</span>
            <span>{label}</span>
            {badge && <span className="ml-auto">{badge}</span>}
        </Link>
    );
}
